import { render, staticRenderFns } from "./AiPersonRemoverDetail.vue?vue&type=template&id=2ced4ccf&scoped=true"
import script from "./AiPersonRemoverDetail.vue?vue&type=script&lang=js"
export * from "./AiPersonRemoverDetail.vue?vue&type=script&lang=js"
import style0 from "./AiPersonRemoverDetail.vue?vue&type=style&index=0&id=2ced4ccf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ced4ccf",
  null
  
)

export default component.exports